import FooterPage from "../components/Custom/Footer/FooterPage";
import Navbar from "../components/Custom/Navbar/Navbar";
import Lotto from "../components/Lotto/Lotto";

export default function Tickets() {
    return (
        <>
            <Navbar />
            <Lotto />
            <FooterPage />
        </>
    );
}
